<breadcrumb endText="Responses" [navigations]="breadcrumbNav" />
<div class="m-5">
  <h1 class="text-xl font-semibold mb-2">
    Responses: {{title}}
  </h1>
  <hr />
  @if (responses.length > 0) {
  <div>
    <div class="grid grid-cols-5 my-3 lg:text-base font-bold">
      <div class="col-span-2">
        Username
      </div>
      <div>
        Response
      </div>
      <div>
        Response Date
      </div>
      <div>
        Response Time
      </div>
      <hr class="col-span-5 mt-2" />
    </div>
    @for (response of responses; track response) {
    <div class="grid grid-cols-5 mb-2 text-base">
      <div class="col-span-2">
        {{response.display_name}}
      </div>
      <div>
        {{response.accepted? 'Accepted' : 'Denied'}}
      </div>
      <div>
        {{response.response_date}}
      </div>
      <div>
        {{response.response_time}}
      </div>
    </div>
    }
    <div class="grid grid-cols-5 mb-1 mt-8">
      <div class="col-span-3 "></div>
      <div class="col-span-2 flex flex-row justify-end lg:justify-center">
        <div
          class="rounded-full bg-[#E5E8EB] w-fit px-1.5 text-xs text-[#74808B] mr-2 flex flex-row items-center justify-evenly">
          <div class="ml-1">
            Responses per page:
          </div>
          <select class="bg-transparent" (change)="perPage()" id="select">
            <fa-icon class="text-[#8B96A2]" [icon]="faCaretDown" />
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
        <div class="rounded-full bg-[#E5E8EB] w-fit px-2 py-1 text-xs text-[#74808B] flex flex-row items-center">
          <button (click)="decrementPage()" [disabled]="pageNumber === 1"><fa-icon
              [ngClass]="pageNumber === 1? 'text-[#B9C2CA]' : 'text-[#74808B]'" [icon]="faChevronLeft" size="xs"
              aria-label="Page Decrement" /></button>
          <div class="mx-1">
            Page {{pageNumber}}
          </div>
          <button (click)="incrementPage()" [disabled]="maxPage === pageNumber"><fa-icon
              [ngClass]="maxPage === pageNumber? 'text-[#B9C2CA]' : 'text-[#74808B]'" [icon]="faChevronRight" size="xs"
              aria-label="Page Increment" /></button>
        </div>
      </div>
    </div>
  </div>
  } @else {
  <div class="flex flex-col gap-6 items-center mt-8">
    <img alt="No Results Image" class="w-[14rem] pointer-events-none" src="../../../assets/images/noResults.svg" />
    <p>This agreement has no responses yet.</p>
    <outline-button (click)="agreementManagement()" text="Return" />
  </div>
  }
</div>